import { useEffect, useState } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import GuBang from "./components/GuBang";
import GuaTian from "./components/GuaTian";
import GenSui from "./components/GenSui";
import ShenPing from "./components/ShenPing";
import Guide from "./components/Guide";
import Subscribe from "./components/Subscribe";
import Footer from "./components/Footer";

function BackToTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="回到顶部"
      className={`fixed bottom-6 right-6 z-40 grid h-11 w-11 cursor-pointer place-items-center rounded-full bg-primary-500 text-background-50 shadow-lg transition-all hover:bg-primary-600 ${
        show ? "opacity-100" : "pointer-events-none opacity-0"
      }`}
    >
      <i className="ri-arrow-up-line text-xl"></i>
    </button>
  );
}

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <GuBang />
        <GuaTian />
        <GenSui />
        <ShenPing />
        <Guide />
        <Subscribe />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}